
      var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMutePressed = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 33,
  viewBox: "0 0 32 33",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mutePressed_1c6aeb26ad3c255f__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.499 4.916V26.714c0 1.143-1.344 1.756-2.207 1.007l-7.365-6.386a1.334 1.334 0 0 0-.874-.326H5.345a1.333 1.333 0 0 1-1.333-1.334V11.63c0-.736.597-1.333 1.333-1.333h4.727c.31 0 .61-.108.848-.305L13.333 8l4.984-4.112c.87-.718 2.182-.1 2.182 1.028Z",
  stroke: "#fff",
  strokeWidth: 2.5,
  strokeLinecap: "round"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mutePressed_1c6aeb26ad3c255f__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.666 16a6.248 6.248 0 0 0-1.708-4.292.81.81 0 0 0-1.175 0 .892.892 0 0 0 0 1.222A4.424 4.424 0 0 1 24.007 16c0 1.15-.44 2.255-1.224 3.068a.885.885 0 0 0-.25.607c-.02.36.177.695.494.842a.81.81 0 0 0 .931-.183 6.25 6.25 0 0 0 1.709-4.335Z",
  fill: "#fff"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#mutePressed_1c6aeb26ad3c255f__c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29 16c-.006-2.529-.97-4.952-2.683-6.745a.814.814 0 0 0-1.184 0 .896.896 0 0 0 0 1.23c2.925 3.047 2.925 7.982 0 11.028a.885.885 0 0 0-.241.615.885.885 0 0 0 .241.616c.157.164.37.256.592.256a.818.818 0 0 0 .592-.256c1.712-1.794 2.677-4.217 2.683-6.745Z",
  fill: "#fff"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "mutePressed_1c6aeb26ad3c255f__a",
  x: 0.58,
  y: 0.873,
  width: 23.351,
  height: 31.338,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.727
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.091
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_15942_165950"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_15942_165950",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mutePressed_1c6aeb26ad3c255f__b",
  x: 20.35,
  y: 10.002,
  width: 7.498,
  height: 13.499,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.727
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.091
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_15942_165950"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_15942_165950",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "mutePressed_1c6aeb26ad3c255f__c",
  x: 22.706,
  y: 7.545,
  width: 8.475,
  height: 18.364,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.727
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.091
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_15942_165950"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_15942_165950",
  result: "shape"
})))));

      const __svgRaw = "<svg width=\"32\" height=\"33\" viewBox=\"0 0 32 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g filter=\"url(#filter0_d_15942_165950)\">\r\n<path d=\"M20.4987 4.91592V14.8604V26.7138C20.4987 27.8565 19.1552 28.4698 18.2918 27.7211L10.9268 21.3346C10.6843 21.1244 10.3742 21.0087 10.0533 21.0087H5.34505C4.60867 21.0087 4.01172 20.4117 4.01172 19.6753V11.6289C4.01172 10.8926 4.60867 10.2956 5.34505 10.2956H10.0718C10.3815 10.2956 10.6815 10.1878 10.9204 9.99075L13.3333 7.99992L18.3167 3.88753C19.1863 3.16993 20.4987 3.78846 20.4987 4.91592Z\" stroke=\"white\" stroke-width=\"2.5\" stroke-linecap=\"round\"/>\r\n</g>\r\n<g filter=\"url(#filter1_d_15942_165950)\">\r\n<path d=\"M25.6665 15.9992C25.6611 14.3909 25.0475 12.8494 23.9581 11.7081C23.6331 11.372 23.1082 11.372 22.7831 11.7081C22.46 12.0463 22.46 12.5923 22.7831 12.9304C23.5668 13.7436 24.0072 14.8477 24.0072 15.9992C24.0072 17.1506 23.5668 18.2548 22.7831 19.0679C22.6261 19.228 22.5363 19.4461 22.5331 19.6748C22.5132 20.0349 22.7098 20.3702 23.0266 20.5167C23.3435 20.6632 23.7145 20.5903 23.9581 20.3336C25.0576 19.1816 25.6721 17.6225 25.6665 15.9992Z\" fill=\"white\"/>\r\n</g>\r\n<g filter=\"url(#filter2_d_15942_165950)\">\r\n<path d=\"M29 15.9993C28.9935 13.4714 28.0294 11.0481 26.3167 9.25494C25.9899 8.91502 25.4601 8.91502 25.1333 9.25494C24.8066 9.59486 24.8066 10.146 25.1333 10.4859C28.0579 13.532 28.0579 18.4666 25.1333 21.5126C24.9773 21.6762 24.8904 21.8977 24.8917 22.1281C24.8904 22.3585 24.9773 22.58 25.1333 22.7436C25.2898 22.9077 25.5028 23 25.725 23C25.9472 23 26.1602 22.9077 26.3167 22.7436C28.0294 20.9504 28.9935 18.5271 29 15.9993Z\" fill=\"white\"/>\r\n</g>\r\n<defs>\r\n<filter id=\"filter0_d_15942_165950\" x=\"0.579901\" y=\"0.873091\" width=\"23.3505\" height=\"31.338\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"0.727273\"/>\r\n<feGaussianBlur stdDeviation=\"1.09091\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_15942_165950\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_15942_165950\" result=\"shape\"/>\r\n</filter>\r\n<filter id=\"filter1_d_15942_165950\" x=\"20.3499\" y=\"10.0015\" width=\"7.4984\" height=\"13.4991\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"0.727273\"/>\r\n<feGaussianBlur stdDeviation=\"1.09091\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_15942_165950\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_15942_165950\" result=\"shape\"/>\r\n</filter>\r\n<filter id=\"filter2_d_15942_165950\" x=\"22.7064\" y=\"7.54545\" width=\"8.47545\" height=\"18.3636\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n<feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n<feOffset dy=\"0.727273\"/>\r\n<feGaussianBlur stdDeviation=\"1.09091\"/>\r\n<feComposite in2=\"hardAlpha\" operator=\"out\"/>\r\n<feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0\"/>\r\n<feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_15942_165950\"/>\r\n<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_15942_165950\" result=\"shape\"/>\r\n</filter>\r\n</defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/mutePressed.1c6aeb26ad3c255fcc47b4905e020046.svg"),
        {
          React: SvgMutePressed,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      